/**
 * Export an array of objects to CSV and trigger download.
 * @param rows Array of row objects
 * @param columns Array of { key, label } for column order and headers
 * @param filename Download filename (e.g. 'user-time-report.csv')
 */
export function exportToCSV<T extends object>(
  rows: T[],
  columns: { key: keyof T; label: string }[],
  filename: string
): void {
  const escape = (v: unknown): string => {
    const s = v === null || v === undefined ? '' : String(v);
    if (s.includes(',') || s.includes('"') || s.includes('\n') || s.includes('\r')) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };
  const header = columns.map((c) => escape(c.label)).join(',');
  const body = rows
    .map((row) => columns.map((c) => escape((row as Record<string, unknown>)[c.key as string])).join(','))
    .join('\n');
  const csv = '\uFEFF' + header + '\n' + body; // BOM for Excel UTF-8
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
